import { Component, OnInit } from '@angular/core';
import {AuthenticationService}  from  '../_services/authentication.service';
import { Router } from '@angular/router';
import { Globals } from '../../Globals';
import { HostListener } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.css']
})
export class MainLayoutComponent implements OnInit {

  menuShow=true;
  isMobile = false;
  constructor(private router: Router, private globals: Globals, private authenticationService: AuthenticationService) {
    var ua = navigator.userAgent;
    if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)){
      // mobile
      this.menuShow = false
      this.isMobile = true

      router.events.subscribe((val) => {
        if(this.menuShow) this.menuShow = false
      });
    }
  }

  ngOnInit() {
  }
  logOut(){
    this.authenticationService.logout();
    this.globals.checkingRefreshToken = true;
    this.router.navigate(['/auth/login']);
  }
}
